import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { Breadcrumb } from '@shared/models';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RktIconComponent, RouterLink],
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs?: Breadcrumb[] = [];
}
